

import { useQuery } from "@tanstack/react-query";
import { listadoTodosProductos, productosParaCarrusel, productosSoloTerminados, productosXCategoria, productosXID } from "../../../services";
import { useCallback, useState } from "react";




export const useProdcutosCArruseles = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['productos-carrusel'], 
        queryFn: () => productosParaCarrusel(),
    });
    return { data, isLoading }
}




export const useProductosXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['productoxid', id], 
        queryFn: () => productosXID(id),
        enabled: !!id,
    });

    return { data, isLoading }
}




export const useTodosProductos = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['productos-todos', { page, termino }], 
        queryFn: () => listadoTodosProductos({ page, termino }),
    });

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}




export const useProductosXCategoria = (id) => {
    const [termino, setTermino] = useState('');

    const chageTermino = useCallback((valor) => {
        setTermino(valor)
    }, [])

    const { data, isLoading } = useQuery({
        queryKey: ['prodcutosxcategoria', { id, termino }], 
        queryFn: () => productosXCategoria({ termino, id }),
        enabled: !!id,
    });

    return { termino, chageTermino, data, isLoading }
}




export const useProductosSoloTerminados = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['productosoloterminados'], 
        queryFn: () => productosSoloTerminados(),
    });

    return { data, isLoading }
}




